import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * MORNING FEEDBACK — lightweight 4-option prompt after a Morning Session
 * (experimental feature analytics). Shown per backend policy
 * (GET /api/morning/feedback-status — currently after the first morning).
 */
const OPTIONS = [
  { id: "neutral", label: "No difference for me" },
  { id: "dislike", label: "I don't like it" },
  { id: "like", label: "It's nice" },
  { id: "love", label: "I really want to keep this" },
];

export const MorningFeedback = ({ sessionId, onDone }) => {
  const [sent, setSent] = useState(false);

  const send = async (id) => {
    if (sent) return;
    setSent(true);
    try {
      await api.post(`/sessions/${sessionId}/morning-feedback`, { response: id });
      toast.success("Thank you — that helps us shape the mornings.");
    } catch {
      /* analytics only — never bother the user with an error */
    }
    onDone?.();
  };

  return (
    <div className="mt-10 glass-strong rounded-2xl p-6 max-w-xl w-full text-left fade-rise" data-testid="morning-feedback-panel">
      <div className="text-xs uppercase tracking-[0.28em] text-amber-200/80 mb-2">
        Morning Sessions — Experimental
      </div>
      <h2 className="font-serif-display text-xl mb-2">How was your Morning Session?</h2>
      <p className="text-violet-50/80 text-sm mb-4">
        One tap is enough — no written review needed.
      </p>
      <div className="flex flex-col gap-2">
        {OPTIONS.map((o) => (
          <button
            key={o.id}
            type="button"
            disabled={sent}
            onClick={() => send(o.id)}
            data-testid={`morning-feedback-${o.id}`}
            className={`text-sm rounded-full px-4 py-2.5 border text-left transition-soft ${
              sent
                ? "border-violet-300/15 text-violet-50/40 cursor-default"
                : "border-violet-300/25 text-violet-50/90 hover:border-violet-300/50 hover:bg-violet-300/10"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MorningFeedback;
